import React from "react";
import { styled } from "@mui/material/styles";
import { Paper, Typography, Stack } from "@mui/material";
import HeightBox from "../HeightBox";
import fontStyles from "./_fontStyles";
import { fontWeight } from "@mui/system";
const Container = styled(Paper)(({ theme }) => ({
  backgroundColor: "transparent",
  outline: "none",
  boxShadow: "none",
}));

const CustomTypography = styled(Typography)(({ theme }) => ({
  fontSize: "11pt",
  fontWeight: 400,
  padding: "10pt 40pt",
}));
export const AddifatMarriagePrintOut = React.forwardRef((props, ref) => {
  const { formValues } = props;
  const secreteriat = formValues.secretarial;
  const addressOne = formValues.address;
  const name = formValues.fullName;
  const religion = formValues.religion;
  const lieceneNumber = formValues.lieceneId;
  const idNumber = formValues.nationalId;
  const issued_date = formValues.passport_issued;
  const spouceName = formValues.spouse;
  const district = formValues.district;
  const secretarial = formValues.secretarial;
  const village = formValues.village;
  const region_sinhala = formValues.region_sinhala;
  return (
    <Container ref={ref}>
      <style type="text/css" media="print">
        {"\
   @page { size: portrait; }\
"}
      </style>
      <img
        src="/images/addifat_marriage.jpg.jpg"
        alt=""
        style={{
          position: "absolute",
          height: "100%",
          width: "100%",
          zIndex: -1,
        }}
      />
      <HeightBox height={240} />

      <CustomTypography>
        ශ්‍රී ලංකා ප්‍රජාතන්ත්‍රවාදී ජනරජයේ{"  "} <span style={{fontWeight:800}}>
        {district ? district : "-"}{" "}</span>දිස්ත්‍රික්කයේ{" "}<span style={{fontWeight:800}}>
        {secreteriat ? secreteriat : "-"}{" "}</span> ප්‍රාදේශීය ලේකම් කොට්ඨාසයේ{" "}
        <span style={{fontWeight:800}}>{village ? village : "-"}{" "}</span> ග්‍රාමයේ{" "}<span style={{fontWeight:800}}> {addressOne ? addressOne : "-"}{" "}</span>
        ලිපිනයෙහි පදිංචි<span style={{fontWeight:800}}>{" "} {name ? name : "-"}{" "}</span>
        වන මම <span style={{fontWeight:800}}>{"   "}{religion} {"   "}</span> බැතිමතියෙක් වශයෙන් අවංකවත් සත්‍ය ලෙසත්
        ගාම්භීරපූර්වකවත් පහත සදහන් පරිදි දිවුරා ප්‍රතිඥා කර සිටිමි.
        <br /> 01.ඉහත නම සදහන් දිවුරුම් ප්‍රකාශයේ දිවුරුම් ප්‍රකාශිකාව මම වෙමි.
        <br /> 02.මාගේ ගමන් බලපත්‍ර අංකය <span style={{fontWeight:800}}> {"   "}{formValues.passport} {"   "}</span>
        වන අතර එය නිකුත් කරන දිනය<span style={{fontWeight:800}}> {"   "}{formValues.passport_issued} {"   "}</span> සහ මාගේ ජාතික හැදුනුම්පත් අංකය<span style={{fontWeight:800}}>{" "}
        {"   "}{idNumber} {"   "}</span> වේ.
        <br /> 03.මා විවාහක වන අතර මාගේ ස්වාමි පුරුෂයාගේ නම<span style={{fontWeight:800}}>{" "}
        {spouceName ? spouceName : "-"}{" "}</span> වේ. <br />
        04.මා හට දරුවන් නොමැත
      </CustomTypography>
      {/* <HeightBox height={0} /> */}
    </Container>
  );
});
